module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preBooking"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('TimeSlots')], 1)]), _vm._v(" "), (typeof _vm.selectedDay === 'undefined') ? _c('div', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n    " + _vm._s(_vm.t('Please select a day')) + "\n  ")]) : _vm._e(), _vm._v(" "), (typeof _vm.selectedDay !== 'undefined' && _vm.availableTimes.length === 0) ? _c('div', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n    " + _vm._s(_vm.t('There are no more bookings available for this day')) + "\n  ")]) : _vm._e(), _vm._v(" "), (typeof _vm.selectedTimeIndex !== 'undefined') ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "adults persons col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-sm removeAdult",
    class: {
      'btn-disabled': (_vm.adults == 0), 'btn-primary': (_vm.adults != 0)
    },
    on: {
      "click": function($event) {
        _vm.removeAdult()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), (_vm.activity.youth_age > 0) ? _c('span', {
    staticClass: "personType"
  }, [_vm._v(" " + _vm._s(_vm.adults) + " "), (_vm.adults !== 1) ? _c('span', [_vm._v(_vm._s(_vm.t('adults')))]) : _c('span', [_vm._v(_vm._s(_vm.t('adult')))])]) : _vm._e(), _vm._v(" "), (_vm.activity.youth_age == 0) ? _c('span', {
    staticClass: "personType"
  }, [_vm._v(" " + _vm._s(_vm.adults) + " "), (_vm.adults !== 1) ? _c('span', [_vm._v(_vm._s(_vm.t('participants')))]) : _c('span', [_vm._v(_vm._s(_vm.t('participant')))])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm addAdult",
    class: {
      'btn-disabled': _vm.isGroupMax, 'btn-primary': !_vm.isGroupMax
    },
    on: {
      "click": function($event) {
        _vm.addAdult()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), (!_vm.activity.is_priced_per_occurrence) ? _c('div', {
    staticClass: "col-xs-4 priceAdults text-xs-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.priceAdults))]), _vm._v("€\n      ")]) : _vm._e()]), _vm._v(" "), (_vm.activity.youth_age > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "children persons m-t-1"
  }, [_c('button', {
    staticClass: "btn btn-sm removeChild",
    class: {
      'btn-disabled': (_vm.children == 0), 'btn-primary': (_vm.children != 0)
    },
    on: {
      "click": function($event) {
        _vm.removeChild()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "personType"
  }, [_vm._v(" " + _vm._s(_vm.children) + " "), (_vm.children !== 1) ? _c('span', [_vm._v(_vm._s(_vm.t('children')))]) : _c('span', [_vm._v(_vm._s(_vm.t('child')))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm addChild",
    class: {
      'btn-disabled': _vm.isGroupMax, 'btn-primary': !_vm.isGroupMax
    },
    on: {
      "click": function($event) {
        _vm.addChild()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), (!_vm.activity.is_priced_per_occurrence) ? _c('div', {
    staticClass: "col-xs-4 m-t-1 priceChildren text-xs-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.priceChildren))]), _vm._v("€\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.activity.youth_age > 0) ? _c('div', [(this.children) ? _c('div', {
    staticClass: "childAges"
  }, [_vm._v(_vm._s(_vm.t('Crianças entre os')) + " "), _c('b', [_vm._v(_vm._s(_vm.activity.minimum_age))]), _vm._v(" " + _vm._s(_vm.t('and')) + " "), _c('b', [_vm._v(_vm._s(_vm.activity.youth_age))]), _vm._v(" " + _vm._s(_vm.t('years old')))]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.isGroupMax) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('small', [_vm._v(_vm._s(_vm.t('The activity is available for')) + " " + _vm._s(this.calendar.times[this.selectedTimeIndex].current_availability) + " " + _vm._s(_vm.t('participants')) + " " + _vm._s(_vm.t('at the selected time')))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row priceTotalContainer"
  }, [_c('div', {
    staticClass: "col-xs-12 priceTotal text-xs-right"
  }, [_vm._v("\n        " + _vm._s(_vm.priceTotal) + " € "), (_vm.activity.is_priced_per_occurrence) ? _c('span', [_vm._v(" / " + _vm._s(_vm.t('group')))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bookNow text-xs-center m-t-1"
  }, [(_vm.calendar.times[_vm.selectedTimeIndex] && _vm.isAnyone) ? _c('router-link', {
    staticClass: "btn btn-primary bookNowBtn",
    attrs: {
      "to": ("/" + _vm.language + "/book/" + (this.activity.slug) + "?oc=" + (_vm.calendar.times[_vm.selectedTimeIndex].id) + "&adults=" + _vm.adults + "&children=" + _vm.children)
    }
  }, [_vm._v(_vm._s(_vm.t('Book now')))]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.t('Book now')))])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-76d81f08", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76d81f08"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Activity/PreBooking.vue
// module id = 792
// module chunks = 3